import { render, staticRenderFns } from "./QuickPractice.vue?vue&type=template&id=25f2f9da&scoped=true"
import script from "./QuickPractice.vue?vue&type=script&lang=js"
export * from "./QuickPractice.vue?vue&type=script&lang=js"
import style0 from "./QuickPractice.vue?vue&type=style&index=0&id=25f2f9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f2f9da",
  null
  
)

export default component.exports